import { FaFingerprint } from 'react-icons/fa6';

export interface PasskeyLoginButtonProps {
  label: string;
  onClick: () => void;
  isPending?: boolean;
  /** Extra Bulma classes (e.g. a color modifier like "is-primary"). */
  className?: string;
}

export const PasskeyLoginButton = ({ label, onClick, isPending, className }: PasskeyLoginButtonProps) => (
  <button
    type="button"
    className={`button is-fullwidth${className ? ` ${className}` : ''}`}
    onClick={onClick}
    disabled={isPending}
  >
    <span className="icon">
      <FaFingerprint />
    </span>
    <span>{label}</span>
  </button>
);
